/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgDribbble(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M2.756 11.677a9.216 9.216 0 002.38 6.524c2.368-3.223 4.794-5.13 7.422-6.067h.001c.196-.07.397-.135.602-.194a32.5 32.5 0 00-.741-1.624c-2.732.87-5.92 1.247-9.664 1.36zm.175-1.507c3.471-.115 6.353-.467 8.785-1.206-.935-1.702-2.059-3.405-3.499-5.408a9.266 9.266 0 00-5.286 6.614zm6.761-7.13c1.399 1.962 2.515 3.676 3.458 5.42 1.947-.781 3.58-1.876 4.986-3.382A9.215 9.215 0 0012 2.75c-.797 0-1.57.1-2.308.29zm9.483 3.122C17.64 7.789 15.877 8.964 13.837 9.8a33.496 33.496 0 01.812 1.809c1.939-.308 4.189-.225 6.6.333a9.21 9.21 0 00-2.074-5.781zm1.96 7.296c-2.202-.536-4.217-.637-5.926-.413.696 1.898 1.314 4.027 1.958 6.628a9.252 9.252 0 003.969-6.215zm-5.326 6.974c-.699-2.863-1.352-5.116-2.09-7.091-.227.062-.447.13-.658.206-2.306.822-4.541 2.54-6.824 5.689A9.211 9.211 0 0012 21.25a9.217 9.217 0 003.809-.818zM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12z'
      />
    </svg>
  );
}

export default SvgDribbble;
